module.exports = __webpack_public_path__ + "img/KLN_logo.0eee7bf0.png";